// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"370":"component---src-pages-markdown-remark-frontmatter-slug-jsx","532":"styles","883":"component---src-pages-404-js"}[chunkId] + "-" + {"370":"7126b646525fa3b4f5fe","532":"a8c0aa462e1f0f1ab994","883":"8716ce76b29e46772401"}[chunkId] + ".js";
};